import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import {
  HttpInterceptorFn,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { authInterceptor } from './auth.interceptor';

export function provideBaseAuth(
  extraInterceptors: HttpInterceptorFn[] = [],
): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideOAuthClient(),
    provideHttpClient(
      withInterceptors([authInterceptor, ...extraInterceptors]),
    ),
  ]);
}
